import {
  Button,
  Card,
  Grid,
  GridCell,
  Icon,
  Stack,
  TextSubtitle,
} from '@pypestream/design-system';
import { TranslationComponent } from '@pypestream/translations';
import {
  sendManagerEvent,
  sendUserEvent,
  useManagerStateMatches,
} from '../../../xstate/app.xstate';
import { AuthMethodTypeEnum } from '@pypestream/api-services';
import { UserDetailsType } from '../../../xstate/user-details-xstate-helper';

export function UserAuthMethods({
  userDetailsState,
  orgId,
  isCurrentUser,
}: {
  userDetailsState: UserDetailsType;
  orgId: string;
  isCurrentUser: boolean;
}) {
  const connectingAuthMethod = useManagerStateMatches(
    'orgRelated.ready.userInfo.connectingAuthMethod'
  );

  return (
    <Grid>
      {userDetailsState.userAuthMethods?.map((_authMethod) => {
        const isPasswordAuthMethod = _authMethod.providerId === 'password';
        return (
          <GridCell
            key={`${_authMethod.accountAuthMethodSettingsId}-${_authMethod.name}`}
          >
            <Card
              size="small"
              border="default"
              shadow="none"
              style={{ width: '100%' }}
              className="c-my-account-form--auth-method-card"
            >
              <Stack alignItems="center" justifyContent="space-between">
                <Stack alignItems="center" gutter="xsmall">
                  <Icon
                    name={
                      isPasswordAuthMethod
                        ? 'email-open'
                        : _authMethod.isCustom
                          ? 'lock'
                          : 'google'
                    }
                    {...(isPasswordAuthMethod && {
                      style: {
                        fill: 'white',
                      },
                    })}
                    size="small"
                  ></Icon>
                  <TextSubtitle size="small">{_authMethod.name}</TextSubtitle>
                </Stack>
                <Stack alignItems="center" gutter="xsmall">
                  {isPasswordAuthMethod && _authMethod.isActive && (
                    <Button
                      variant="secondary"
                      disabled={!userDetailsState.userName || !isCurrentUser}
                      onClick={() => {
                        sendUserEvent({
                          type: 'user.signOut',
                          redirectURL: `${import.meta.env.FE_AUTH_URL}/recovery?emailId=${
                            userDetailsState.userName
                          }`,
                        });
                      }}
                      size="small"
                    >
                      <TranslationComponent i18nKey="manager/preferences:general.reset_password">
                        Reset Password
                      </TranslationComponent>
                    </Button>
                  )}
                  {_authMethod.isActive ? (
                    <Icon
                      name="check"
                      size="small"
                      variant="filled"
                      color="green"
                      style={{
                        // @ts-expect-error unknown property
                        '--icon-stroke-width--custom': '2.5',
                      }}
                    />
                  ) : (
                    <Button
                      size="small"
                      variant="primary"
                      onClick={() => {
                        if (isPasswordAuthMethod) {
                          sendManagerEvent({
                            type: 'manager.connectingAuthMethod',
                            userId: userDetailsState.id || '',
                            accountAuthMethodSettingsId:
                              _authMethod.accountAuthMethodSettingsId || '',
                            authMethodName: _authMethod.name || '',
                          });
                        } else {
                          window.location.href = `${import.meta.env.FE_AUTH_URL}/settings?providerId=${_authMethod.providerId}&userId=${userDetailsState.id}&accountAuthMethodSettingsId=${_authMethod.accountAuthMethodSettingsId}&orgId=${orgId}&authMethodName=${_authMethod.name}&isSaml=${_authMethod.type === AuthMethodTypeEnum.Saml}`;
                        }
                      }}
                      disabled={connectingAuthMethod || !isCurrentUser}
                    >
                      {connectingAuthMethod ? 'Connecting...' : 'Set up'}
                    </Button>
                  )}
                </Stack>
              </Stack>
            </Card>
          </GridCell>
        );
      })}
    </Grid>
  );
}
